import React, { PureComponent, ErrorInfo } from "react";
import { RouteComponentProps } from "@reach/router";

export interface BasePureComponentProps extends RouteComponentProps { }

class BasePureComponent<
  Props extends BasePureComponentProps
  > extends PureComponent<Props> {
  componentDidCatch = (error: Error, errorInfo: ErrorInfo) => {
    console.group("Error");
    console.error(error);
    console.error(errorInfo);
    console.groupEnd();
  };
}

export default BasePureComponent;
